// Single source of truth for "are we running on the canonical prod host?".
// True only on inventory.cambonic.com; anything else (localhost, LAN IP, the
// dev/preview worker) is treated as DEV. The same code bundle ships to both
// environments, so this hostname check is the only runtime signal of which one
// we're in. Consumed by main.tsx (favicon/title swap) and usePollActive (no
// auto-polling outside prod — cuts free-tier Supabase egress from open Dev tabs).
export function isProdHost(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.location.hostname === 'inventory.cambonic.com'
  );
}
